import { Modal, Label } from "semantic-ui-react";
import PayContract from "../PayContract";
import { Link } from "react-router-dom";

const GreaterOfContract = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.closeContractDetailsModal}
            closeIcon
            size={'fullscreen'}
        >
            <Modal.Header>
                Provider Details - {props.doctorABBR} ({props.contractType})
                {props.isProdMove && <Label className="float-right large"
                    style={{ paddingLeft: '30px', color: '#1c18c9', backgroundColor: '#dddddd57' }}>
                    <Link
                        to={{ pathname: `/payandreports/productionmove/${props.startDate}` }} target="_blank">
                        Production Move
                    </Link>
                </Label>
                }
                <Label className="float-right large" style={{ color: '#ffffff', backgroundColor: '#166b83' }}>
                    <Link to={`/doctor-contracts/${props.docUserId}`} target="_blank" rel="noopener noreferrer">
                        Contract Link
                    </Link>
                </Label>
            </Modal.Header>
            <Modal.Content scrolling>
                <PayContract
                    {...props}
                />
            </Modal.Content>
        </Modal>
    )
}

export default GreaterOfContract;
